<script lang="ts" setup>
import { provide, shallowRef, onMounted } from 'vue'
import { useFeatureFlags } from '@previo/feature-flags'
import router from '~/router'
import { LayoutComponents } from '~/layouts'
import FileShareDialog from '~/components/file-share-dialog/FileShareDialog.vue'
import { globalComponents } from '~/globalComponents'

const layout = shallowRef<typeof LayoutComponents>()

router.afterEach((to) => {
  layout.value = LayoutComponents[to.meta.layout]
})

provide('app:layout', layout)

onMounted(() => {
  useFeatureFlags().startup()
})
</script>

<template>
  <main>
    <component :is="layout || 'div'">
      <slot />
    </component>
    <file-share-dialog :ref="globalComponents.register.fileShareDialog" />
  </main>
</template>
